import React, { memo, useCallback, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import FavoriteItem from "./FavoriteItem";
import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from "@material-ui/core";
import { Button, Card } from "react-bootstrap";
import { Delete, ShoppingCart } from "@material-ui/icons";
// import { Scrollbars } from "react-custom-scrollbars";
import reactStringReplace from "react-string-replace";
import t from "../../i18n/translate";
import { debounce } from "lodash";
import { useFavorites } from "../../contexts/favorites/use-favorites";
import QuickView from "../QuickView/QuickView";
import {
	EmptyFavoritesContent,
	FavoriteItemsWrapper,
	FavoritesEmpty,
	FavoritesHeader,
	FavoritesViewAll,
	PageWrapper,
	TitleFavorites,
	TitleFavoritesCount,
} from "./Favorites.style";
import { logClearWishlist, logPageView, logViewItem } from "../../services/googleAnalytics";

function Favorites({ props, cartType, type, color, limit, loader, notificationId }) {
	const {
		favorites,
		favoritesMessage,
		totalFavoriteItems,
		removeAllItemsFromFavorites,
		handleLoadMore,
		next,
		isLoadMore,
		favLoading,
	} = useFavorites();
	const scrollRef = useRef(null);
	const history = useHistory();

	const [isOpen, setIsOpen] = useState(false);
	const [show, setShow] = useState(false);

	const onHide = () => setShow(false);

	const handleQuickViewModal = (modalProps, index) => {
		// console.log(modalProps, props);
		props.ProductModalData(modalProps);

		setShow(true);
		// trackClick(modalProps, index);
		// trackDetails(modalProps, index);
	};
	const handleOpen = () => {
		setIsOpen((prev) => !prev);
	};

	const handleDeleteAllFavorites = async () => {
		handleOpen();
		logClearWishlist();
		await removeAllItemsFromFavorites({ type });
	};

	// const handleScroll = useCallback(
	// 	debounce(() => {
	// 		const query = { page: 1, limit, type };
	// 		// const wrappedElement = document.querySelector(".favorite-items-container");
	// 		if (
	// 			// wrappedElement &&
	// 			// wrappedElement?.getBoundingClientRect()?.bottom <=
	// 			// 	scrollRef.current?.getScrollHeight()
	// 			scrollRef.current?.getClientHeight() + scrollRef.current?.getScrollTop() >=
	// 			scrollRef.current?.getScrollHeight() - 1
	// 		) {
	// 			handleLoadMore(query);
	// 		}
	// 	}, 350),
	// 	[next, isLoadMore, favorites]
	// );

	const handleClickShowMore = () => {
		const query = { page: 1, limit, type };
		handleLoadMore(query);
	};

	const isInViewport = useCallback(
		debounce(() => {
			const wrappedElement = document.querySelector(".favorite-items-container");
			if (
				wrappedElement &&
				wrappedElement.getBoundingClientRect().bottom <= window.outerHeight
			) {
				if (document.getElementById("showMore")) {
					document.getElementById("showMore").click();
				}
			}
		}, 100),
		[next, isLoadMore, favorites]
	);

	useEffect(() => {
		document.addEventListener("scroll", isInViewport);

		return () => {
			document.removeEventListener("scroll", isInViewport);
		};
	}, []);

	const totalItemsCount = reactStringReplace(
		t("favorites_items_total_count", false),
		/({path})/g,
		() => totalFavoriteItems
	);

	return (
		<PageWrapper>
			<Card style={{ width: "100%", height: "100%", border: "none", padding: 0 }}>
				<Card.Header
					className="d-flex align-items-center px-0 py-1"
					style={{ background: "#ffffff", border: "none" }}
				>
					<FavoritesHeader>
						{totalFavoriteItems >= 1 ? (
							<TitleFavoritesCount className="total-items-count">{totalItemsCount}</TitleFavoritesCount>
						) : null}
						<TitleFavorites className="favorites-title">{!notificationId ? t("favorites_title") : t("favorites_back_stock")}</TitleFavorites>
						{totalFavoriteItems >= 1 && !notificationId ? (
							<Button
								variant="light"
								size="sm"
								className="text-danger"
								onClick={handleOpen}
							>
								<FavoritesEmpty className="empty-button-label text-danger mr-1">
									{t("favorites_button_empty_label")}
								</FavoritesEmpty>
								<Delete className="text-danger" />
							</Button>
						) : null}
						{notificationId && 
							(
								<FavoritesViewAll rel="noopener noreferrer" href="/favorites" style={{textDecoration: "none", color: "inherit"}}>
								{ t('favorites_view_all_label') }
								</FavoritesViewAll>
							)
						}
					</FavoritesHeader>
				</Card.Header>
				<Card.Body className="p-0">
					{favorites.length >= 1 ? (
						<FavoriteItemsWrapper className="favorite-items-container">
							{favorites?.map((item, index) => (
								<FavoriteItem
									key={item.item_id}
									data={item}
									cartType={cartType}
									type={type}
									itemId={item.item_id}
									sku={item.product_code}
									name={item.name}
									itemRefId={item.item_ref_id}
									imgUrl={item.default_image_url}
									countryCode={item.countries[0]?.code ?? null}
									price={item.store_items_price_types[0].mrp}
									salePrice={item.store_items_price_types[0].price}
									promo={item.promo}
									promoPrice={item.promo === 1 ? item.promo_price : null}
									promoStartDate={item.promo === 1 ? item.promo_start_date : null}
									promoEndDate={item.promo === 1 ? item.promo_end_date : null}
									outOfStock={!item.store_items_price_types[0].available_quantity}
									isSameDay={item.same_day ?? 0}
									isAvailableTomorrow={item.available_tommorrow ?? 0}
									isAvailableTomorrowExpress={item.available_tomorrow_express ?? 0}
									isShopOpen={item.is_shop_open ?? false}
									isShopNormalOpen={item.is_shop_normal_open ?? false}
									notificationId={notificationId}
									weight={
										item.store_items_price_types[0].name !== ""
											? item.store_items_price_types[0].name
											: item.store_items_price_types[0].weight +
											  " " +
											  item.store_items_price_types[0].weight_unit
									}
									brandId={
										item.brand_id === 0 || item.brand_id === null ? 0 : item.brand_id
									}
									brands={props.brands}
									color={color}
									loader={loader}
									onClick={() => {
										if (cartType === "express") {
                      						logViewItem(item)
											handleQuickViewModal(item, index);
										} else {
											logPageView(`/product/${item.item_ref_id}`)
                      						logViewItem(item,(`/product/${item.item_ref_id}`))
											history.push(`/product/${item.item_ref_id}`);
											window.scrollTo(0, 0);
										}
									}}
								/>
							))}
							{isLoadMore && favorites?.length < totalFavoriteItems ? (
								<div className="w-100 rounded rounded-2 d-flex align-items-center justify-content-center">
									<Button
										id={"showMore"}
										onClick={handleClickShowMore}
										size="small"
										variant="outline-light"
									>
										{loader("relative")}
									</Button>
								</div>
							) : null}
						</FavoriteItemsWrapper>
					) : favLoading ? (
						loader("relative")
					) : (
						<EmptyFavoritesContent>
							<img
								className="empty-favorites-image"
								src="https://cdn.shopify.com/s/files/1/0510/4487/6480/t/11/assets/empty-wishlist.png?v=141658177206755846691632865697"
								alt="Not Found"
							/>
							<p className="empty-favorites-title">{t("favorites_empty_label")}</p>
							{favoritesMessage !== null && <p style={{fontWeight: 500}}>{favoritesMessage}</p>}
							<div
								className={`start-browsing-btn ${cartType}`}
								onClick={() => {
									if (cartType === "express") {
										history.push("/express");
									} else {
										history.push("/");
									}
								}}
							>
								<Button variant="light">
									{t("favorites_button_start_browsing")} <ShoppingCart />
								</Button>
							</div>
						</EmptyFavoritesContent>
					)}
				</Card.Body>
			</Card>

			{/* Dialog Delete All Favorites */}
			<Dialog
				open={isOpen}
				onClose={handleOpen}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">
					{t("favorites_empty_modal_title")}
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-warning-question">
						{t("favorites_empty_modal_warning_question")}
					</DialogContentText>
					<DialogContentText id="alert-dialog-warning-note">
						{t("favorites_empty_modal_warning_note")}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button size="sm" variant="light" onClick={handleOpen}>
						{t("favorites_empty_button_cancel_label")}
					</Button>
					<Button
						size="sm"
						variant="outline-danger"
						onClick={handleDeleteAllFavorites}
					>
						{t("favorites_empty_button_delete_label")}
					</Button>
				</DialogActions>
			</Dialog>

			{/* QuickView */}
			{show && (
				<QuickView
					show={show}
					onHide={onHide}
					props={props}
					// deviceType={deviceType}
					// onCartClick={() => {
					// 	handleJoin();
					// }}
				/>
			)}
		</PageWrapper>
	);
}

export default memo(Favorites);
